import Button from "./Button";
interface PreviosBtnProps {
    progressProcess: (n: number) => void;
}

/**
 * @author cjs
 * @date 2024-09-12 11:26:58
 * @remark 지도만들기 화면 이전 버튼
 * @param props
 * @props PreviosBtnProps
 *      progressProcess (required) : 지도만들기 과정 페이지 변경 함수
 * @returns PreviousBtn
 */

function PreviousBtn(props: PreviosBtnProps) {
    return <Button label={"이전"} size={"large"} background={"var(--main-color)"} onClick={() => props.progressProcess(-1)} />;
}

export default PreviousBtn;
